import { render, staticRenderFns } from "./MdGroupNote.vue?vue&type=template&id=aa4816b2&"
import script from "./MdGroupNote.vue?vue&type=script&lang=js&"
export * from "./MdGroupNote.vue?vue&type=script&lang=js&"
import style0 from "./MdGroupNote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports